
stateProviders.push({
    name: 'schoolside.settings.parentApp.language',
    url: '/language',
    templateUrl: 'fast/submodules/schoolside/settings/parentApp/language/partials/language.html?v=' + versionNo,
    controller: 'LanguageController',
    resolve: {
      school: function(SchoolModelService)
        {
            return SchoolModelService.get();
        }
    }
});